import { EnforcementMode } from 'us-web-services';

export const SIGNAL_TYPE_LABELS: Record<string, string> = {
  EMAIL: 'Email',
  PHONE: 'Phone',
  IP: 'IP Address',
  DEVICE_TOKEN: 'Device',
  USER_AGENT: 'User Agent',
};

export const TIER_LABELS: Record<string, string> = {
  CONFIRMED: 'Confirmed',
  MEDIUM_HIGH: 'Medium-High',
  LOW: 'Low',
};

export const REVIEW_OUTCOME_LABELS: Record<string, string> = {
  CONFIRMED_BLOCK: 'Blocked',
  UNBLOCKED: 'Unblocked',
};

export const ENFORCEMENT_OPTIONS: {
  value: EnforcementMode;
  label: string;
  description: string;
}[] = [
  {
    value: 'OFF',
    label: 'Off',
    description: 'Scores and logs all registrations but takes no action.',
  },
  {
    value: 'ON',
    label: 'On',
    description: 'Flagged registrations are silently blocked and submitted for review.',
  },
];
